import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { CONTENT } from "@/content";
import { useSettings } from "@/lib/settings";

const S = CONTENT.share;

const Modal = ({ onClose, children, testId }) => {
  const closeRef = useRef(null);
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    closeRef.current?.focus();
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="modal-overlay" onClick={onClose} data-testid={`${testId}-overlay`}>
      <div className="modal-card" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()} data-testid={testId}>
        <button ref={closeRef} className="modal-x" onClick={onClose} aria-label={S.closeAria} data-testid={`${testId}-x`}>×</button>
        {children}
      </div>
    </div>
  );
};

export const PrayerModal = ({ onAmen, onCancel }) => {
  const p = useSettings().settings.prayer_card;
  return (
    <Modal onClose={onCancel} testId="prayer-card">
      <span className="pill">{S.prayerPill}</span>
      <h2 className="modal-title" data-testid="prayer-card-title">{p.title}</h2>
      <p className="modal-text" data-testid="prayer-card-text">{p.text}</p>
      <button className="nb-btn" onClick={onAmen} data-testid="prayer-card-close-button">{p.close_label}</button>
    </Modal>
  );
};

export const ThankYouModal = ({ onClose }) => {
  const t = useSettings().settings.thank_you;
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  const go = (to) => { onClose(); navigate(to); };
  return (
    <Modal onClose={onClose} testId="thank-you">
      <div className="ty-head">
        <span className="ty-ripple" aria-hidden="true"><span /><span /><span /></span>
        <h2 className="modal-title" data-testid="thank-you-heading">{t.heading}</h2>
      </div>
      <p className="modal-text" data-testid="thank-you-message">{t.message}</p>
      <div className="row-actions">
        <button className="nb-btn" onClick={() => go("/library")} data-testid="thank-you-button-1">{t.button1}</button>
        <button className="nb-btn ghost" onClick={() => go(isSignedIn ? "/my-shares" : "/account")} data-testid="thank-you-button-2">{t.button2}</button>
      </div>
    </Modal>
  );
};
